import {Localization} from '@hconnect/uikit'

const defaultNamespace = 'translations'

const props = {
  ns: [defaultNamespace, 'adminconsole'],
  backend: {
    loader: (filename, packageName?: string | null) => {
      if (process.env.NODE_ENV === 'development') {
        console.info(`Load Translation for hub [${filename}]`)
      }
      if (packageName === 'adminconsole') {
        return import(`../../../adminconsole/src/localization/${filename}.json`).catch((err) => {
          if (process.env.NODE_ENV === 'development') {
            console.error(
              `Could not load Translation for hub [${filename}] in namespace [${packageName}]`
            )
          }
          return {err}
        })
      }
      return import(`./${filename}.json`).catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.error(`Could not load Translation for hub [${filename}]`)
        }
        return {err}
      })
    }
  }
}

export default () => Localization(props)
